export enum QuestState {
  Incomplete,
  Claimable,
  Complete,
}
